<template>
  <div class="content">
    <div class="header">
      <v-layout row wrap align-center class="hero" :style="header()">
        <v-container fluid>
          <v-row>
            <v-col>
              <h2 class="display-2 text-center white--text pb-12">CONTACT</h2>
            </v-col>
          </v-row>
        </v-container>
      </v-layout>
    </div>

    <v-container>
      <Title title="Contact Me" subtitle="get in touch" />
      <v-card class="card pa-6 mb-8">
        <!-- <v-snackbar v-model="snackbar" absolute top right color="success">
              <span>Registration successful!</span>
              <v-icon dark>mdi-checkbox-marked-circle</v-icon>
            </v-snackbar>-->
        <v-form
          ref="form"
          action="https://formcarry.com/s/ErZ0hITLK5n"
          method="post"
          accept-charset="UTF-8"
        >
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.firstName"
                  :rules="rules.name"
                  color="purple"
                  type="text"
                  label="First name"
                  name="FirstName"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.lastName"
                  :rules="rules.name"
                  type="text"
                  color="purple"
                  label="Last name"
                  name="LastName"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.email"
                  :rules="rules.email"
                  color="purple"
                  type="email"
                  label="Email"
                  name="Email"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.company"
                  color="purple"
                  type="text"
                  name="Company"
                >
                  <template v-slot:label>
                    <div>
                      Company
                      <small>(optional)</small>
                    </div>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.message"
                  :rules="rules.message"
                  color="purple"
                  label="Message"
                  name="Message"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn
              :disabled="!formIsValid"
              type="submit"
              raised
              rounded
              class="white--text"
              color="#b697ff"
            >
              SEND MESSAGE
              <v-icon right>mdi-email</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Title from "../components/Title";
// import GeoImage from "../components/GeoImage";

export default {
  components: {
    Title
    // GeoImage
  },
  data() {
    const defaultForm = Object.freeze({
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      message: ""
    });
    return {
      //TODO: Change background image for Contact page
      background: require("@/assets/background.jpg"),
      form: Object.assign({}, defaultForm),
      rules: {
        name: [(val) => (val || "").length > 0 || "This field is required"],
        message: [
          (val) =>
            (val || "").length > 20 ||
            "This field must be more than 20 characters"
        ],
        email: [
          (val) =>
            this.validEmail(val) == true ||
            "This field must conatain a valid email address"
        ]
      },
      snackbar: false,
      defaultForm
    };
  },

  computed: {
    formIsValid() {
      return (
        this.form.firstName &&
        this.form.lastName &&
        this.validEmail(this.form.email) &&
        this.form.message.length > 20
      );
    }
  },
  methods: {
    resetForm() {
      this.form = Object.assign({}, this.defaultForm);
      this.$refs.form.reset();
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    submit() {
      this.snackbar = true;
      this.resetForm();
    },
    header() {
      return {
        backgroundImage: `url(${this.background})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background-color: #fff;

  .header {
    // height: 100vh,
    height: 50vh;
  }
  .hero {
    height: 100%;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
  .image {
    margin: auto;
  }
  .card {
    border-radius: 15px;
  }
}
</style>
